import { env } from "@env/environment";
import { Injectable } from "@angular/core";
import { MapperFiltroRicercaAnagrafe } from "../mapper/gescor/mpper-filtro-ricerca-anagrafe";
import { PaginazioneVO } from "../vo/paginazioneVO";
import { Observable } from "rxjs";
import { EntitaAnagrafeVO } from "../vo/gescor/entita-anagrafeVO";
import { FiltroRicercaAnagrafeVO } from "../vo/gescor/filtro-ricerca-anagrafeVO";
import { MapperEntitaAnagrafeEstesa } from "../mapper/anagrafe/mapper-entita-anagrafe-estesa";
import { EntitaAnagrafeEstesaDTO } from "../dto/anagrafe/entita-anagrafe-estesaDTO";
import { EventSourcePolyfill } from "event-source-polyfill";
import { AutenticazioneService } from "./autenticazione.service";

@Injectable({
  providedIn: "root"
})
export class AnagrafeSseventsService {
  private urlRicercaSemplice: string =
    env.API_URL_BASE + env.URL_RICERCA_ANAGRAFE_ESTESA_SSE;

  private urlRicercaAvanzataAnagrafeEstesa: string =
    env.API_URL_BASE + env.URL_RICERCA_AVANZATA_ANAGRAFE_ESTESA_SSE;

  private arrayOfRecapitiToExclude = new Array<string>();

  constructor(
    private mapperEntitaAnagrafeEstesa: MapperEntitaAnagrafeEstesa,
    private mapperFiltroRicercaAnagrafe: MapperFiltroRicercaAnagrafe,
    private autenticazioneService: AutenticazioneService
  ) {
    this.arrayOfRecapitiToExclude = env.LISTA_RECAPITO_TO_EXCLUDE.split(",");
    this.arrayOfRecapitiToExclude = this.arrayOfRecapitiToExclude.map(
      function (x) {
        return x.toUpperCase();
      }
    );
    console.log("[AnagrafeSseventsService.constructor] this.arrayOfRecapitiToExclude:", this.arrayOfRecapitiToExclude);
  }

  public ricercaSempliceSSe(
    val: string,
    tipiRecapito: string,
    page: PaginazioneVO,
    provvisori: boolean = true
  ): Observable<EntitaAnagrafeVO> {
    const url: string =
      this.urlRicercaSemplice +
      "?filtro=" +
      val +
      "&tipiRecapito=" +
      tipiRecapito +
      "&pageElement=" +
      page.size +
      "&pageNumber=" +
      page.pageNumber +
      "&provvisori=" +
      provvisori;
    
    const arrayOfRecapitiToExclude = env.LISTA_RECAPITO_TO_EXCLUDE.split(",");
    // if (this.eventSource) {
    //   this.eventSource.close();
    // }
    const eventSource: EventSourcePolyfill = new EventSourcePolyfill(url, {
      headers: {
        Authorization: "Bearer " + this.autenticazioneService.getUtente().token
      }
    });
    return Observable.create(observer => {
      eventSource.onmessage = event => {
        let entityAngrafeEstesaDTO: EntitaAnagrafeEstesaDTO;
        entityAngrafeEstesaDTO = JSON.parse(event.data);
        console.log("[AnagrafeSseventsService.ricercaSempliceSSe] entityAngrafeEstesaDTO:", entityAngrafeEstesaDTO);
        if (!this.isExcluded(entityAngrafeEstesaDTO)) {
          observer.next(
            this.mapperEntitaAnagrafeEstesa.convertDtoToVo(entityAngrafeEstesaDTO)
          );
        } else {
          console.log("[AnagrafeSseventsService.ricercaSempliceSSe] E X C L U D E:", entityAngrafeEstesaDTO);
        }
      };
      eventSource.onerror = _ => {
        console.log("ricercaSempliceSSe ", val, tipiRecapito, " chiusa");
        observer.complete();
        eventSource.close();
      };
    });
  }

  public isExcluded(entityAngrafeEstesaDTO: EntitaAnagrafeEstesaDTO): boolean {
    let bool = true;
    bool = entityAngrafeEstesaDTO != null && this.isExcludedStr(entityAngrafeEstesaDTO.identificativoRecapito);
    return bool;
  }

  public isExcludedStr(recapito: string): boolean {
    let bool = true;
    bool = recapito != null
      && this.arrayOfRecapitiToExclude.indexOf(recapito.toUpperCase()) !== -1;
    return bool;
  }


  public creaRicercaAvanzataEstesa(
    filtroRicercaAnagrafeVO: FiltroRicercaAnagrafeVO,
    tipiRecapito: string,
    page: PaginazioneVO,
    provvisori: boolean = true
  ): EventSourcePolyfill {
    const filtro = this.mapperFiltroRicercaAnagrafe.convertVoToDto(
      filtroRicercaAnagrafeVO
    );
    const encoded: string = btoa(JSON.stringify(filtro));
    const url: string =
      this.urlRicercaAvanzataAnagrafeEstesa +
      "?tipiRecapito=" +
      tipiRecapito +
      "&provvisori=" +
      provvisori;
    
    return new EventSourcePolyfill(url, {
      headers: {
        Authorization: "Bearer " + this.autenticazioneService.getUtente().token,
        X_anag_corr: encoded
      },
    });
  }


  public ricercaAvanzataEstesa(eventSource: EventSourcePolyfill): Observable<EntitaAnagrafeVO> {

    return Observable.create((observer) => {
      eventSource.onmessage = (event) => {
        let entityAngrafeEstesaDTO: EntitaAnagrafeEstesaDTO;
        entityAngrafeEstesaDTO = JSON.parse(event.data);
        console.log(
          "[AnagrafeSseventsService.ricercaAvanzataEstesa] entityAngrafeEstesaDTO:",
          entityAngrafeEstesaDTO
        );
        if (!this.isExcluded(entityAngrafeEstesaDTO)) {
          observer.next(
            this.mapperEntitaAnagrafeEstesa.convertDtoToVo(
              JSON.parse(event.data)
            )
          );
        } else {
          console.log(
            "[AnagrafeSseventsService.ricercaAvanzataEstesa] E X C L U D E:",
            entityAngrafeEstesaDTO
          );
        }
      };
      eventSource.onerror = (_) => {
        console.log("ricercaAvanzataEstesa chiusa");
        observer.complete();
        eventSource.close();
      };
    });
  }
}
